/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as JoinImport } from './routes/join'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as OauthConsentImport } from './routes/oauth/consent'
import { Route as AuthCallbackImport } from './routes/auth/callback'
import { Route as AuthWorkoutSessionImport } from './routes/_auth/workout-session'
import { Route as AuthDashboardImport } from './routes/_auth/_dashboard'
import { Route as unauthRegisterImport } from './routes/(unauth)/register'
import { Route as unauthLoginImport } from './routes/(unauth)/login'
import { Route as unauthForgotImport } from './routes/(unauth)/forgot'
import { Route as setupSetupImport } from './routes/(setup)/setup'
import { Route as AuthDashboardVaultImport } from './routes/_auth/_dashboard/vault'
import { Route as AuthDashboardUpgradeImport } from './routes/_auth/_dashboard/upgrade'
import { Route as AuthDashboardTeamImport } from './routes/_auth/_dashboard/team'
import { Route as AuthDashboardSupplementsImport } from './routes/_auth/_dashboard/supplements'
import { Route as AuthDashboardReferImport } from './routes/_auth/_dashboard/refer'
import { Route as AuthDashboardPackagesImport } from './routes/_auth/_dashboard/packages'
import { Route as AuthDashboardMetricsImport } from './routes/_auth/_dashboard/metrics'
import { Route as AuthDashboardMealsImport } from './routes/_auth/_dashboard/meals'
import { Route as AuthDashboardHabitsImport } from './routes/_auth/_dashboard/habits'
import { Route as AuthDashboardGettingStartedImport } from './routes/_auth/_dashboard/getting-started'
import { Route as AuthDashboardFoodsImport } from './routes/_auth/_dashboard/foods'
import { Route as AuthDashboardExercisesImport } from './routes/_auth/_dashboard/exercises'
import { Route as AuthDashboardDashboardImport } from './routes/_auth/_dashboard/dashboard'
import { Route as AuthDashboardCheckinsImport } from './routes/_auth/_dashboard/checkins'
import { Route as AuthDashboardChatImport } from './routes/_auth/_dashboard/chat'
import { Route as AuthDashboardBrandingImport } from './routes/_auth/_dashboard/branding'
import { Route as AuthDashboardWorkoutsIndexImport } from './routes/_auth/_dashboard/workouts/index'
import { Route as AuthDashboardTrainingIndexImport } from './routes/_auth/_dashboard/training/index'
import { Route as AuthDashboardNutritionIndexImport } from './routes/_auth/_dashboard/nutrition/index'
import { Route as AuthDashboardLeadsIndexImport } from './routes/_auth/_dashboard/leads/index'
import { Route as AuthDashboardFormsIndexImport } from './routes/_auth/_dashboard/forms/index'
import { Route as AuthDashboardClientsIndexImport } from './routes/_auth/_dashboard/clients/index'
import { Route as AuthDashboardWorkoutsWorkoutIdImport } from './routes/_auth/_dashboard/workouts/$workoutId'
import { Route as AuthDashboardTrainingTemplateIdImport } from './routes/_auth/_dashboard/training/$templateId'
import { Route as AuthDashboardSettingsLayoutImport } from './routes/_auth/_dashboard/settings/_layout'
import { Route as AuthDashboardNutritionTemplateIdImport } from './routes/_auth/_dashboard/nutrition/$templateId'
import { Route as AuthDashboardLeadsLeadIdImport } from './routes/_auth/_dashboard/leads/$leadId'
import { Route as AuthDashboardFormsFormIdImport } from './routes/_auth/_dashboard/forms/$formId'
import { Route as AuthDashboardSettingsLayoutIndexImport } from './routes/_auth/_dashboard/settings/_layout/index'
import { Route as AuthDashboardSettingsLayoutSubscriptionImport } from './routes/_auth/_dashboard/settings/_layout/subscription'
import { Route as AuthDashboardSettingsLayoutSecurityImport } from './routes/_auth/_dashboard/settings/_layout/security'
import { Route as AuthDashboardSettingsLayoutOrganisationImport } from './routes/_auth/_dashboard/settings/_layout/organisation'
import { Route as AuthDashboardClientsClientIdLayoutImport } from './routes/_auth/_dashboard/clients/$clientId/_layout'
import { Route as AuthDashboardClientsClientIdLayoutIndexImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/index'
import { Route as AuthDashboardClientsClientIdLayoutVaultImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/vault'
import { Route as AuthDashboardClientsClientIdLayoutTrainingImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/training'
import { Route as AuthDashboardClientsClientIdLayoutSettingsImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/settings'
import { Route as AuthDashboardClientsClientIdLayoutRoadmapImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/roadmap'
import { Route as AuthDashboardClientsClientIdLayoutNutritionImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/nutrition'
import { Route as AuthDashboardClientsClientIdLayoutMetricsImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/metrics'
import { Route as AuthDashboardClientsClientIdLayoutHabitsImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/habits'
import { Route as AuthDashboardClientsClientIdLayoutGalleryImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/gallery'
import { Route as AuthDashboardClientsClientIdLayoutActivityImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/activity'
import { Route as AuthDashboardClientsClientIdLayoutCheckinIndexImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/checkin/index'
import { Route as AuthDashboardClientsClientIdLayoutCheckinCompareImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/checkin/compare'
import { Route as AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdImport } from './routes/_auth/_dashboard/clients/$clientId/_layout/checkin/$formId.$responseId'

// Create Virtual Routes

const AuthDashboardSettingsImport = createFileRoute(
  '/_auth/_dashboard/settings',
)()
const AuthDashboardClientsClientIdImport = createFileRoute(
  '/_auth/_dashboard/clients/$clientId',
)()

// Create/Update Routes

const ResetPasswordRoute = ResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const JoinRoute = JoinImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const OauthConsentRoute = OauthConsentImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRoute,
} as any)

const AuthCallbackRoute = AuthCallbackImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRoute,
} as any)

const AuthWorkoutSessionRoute = AuthWorkoutSessionImport.update({
  id: '/workout-session',
  path: '/workout-session',
  getParentRoute: () => AuthRoute,
} as any)

const AuthDashboardRoute = AuthDashboardImport.update({
  id: '/_dashboard',
  getParentRoute: () => AuthRoute,
} as any)

const unauthRegisterRoute = unauthRegisterImport.update({
  id: '/(unauth)/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const unauthLoginRoute = unauthLoginImport.update({
  id: '/(unauth)/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const unauthForgotRoute = unauthForgotImport.update({
  id: '/(unauth)/forgot',
  path: '/forgot',
  getParentRoute: () => rootRoute,
} as any)

const setupSetupRoute = setupSetupImport.update({
  id: '/(setup)/setup',
  path: '/setup',
  getParentRoute: () => rootRoute,
} as any)

const AuthDashboardSettingsRoute = AuthDashboardSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardVaultRoute = AuthDashboardVaultImport.update({
  id: '/vault',
  path: '/vault',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardUpgradeRoute = AuthDashboardUpgradeImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardTeamRoute = AuthDashboardTeamImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardSupplementsRoute = AuthDashboardSupplementsImport.update({
  id: '/supplements',
  path: '/supplements',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardReferRoute = AuthDashboardReferImport.update({
  id: '/refer',
  path: '/refer',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardPackagesRoute = AuthDashboardPackagesImport.update({
  id: '/packages',
  path: '/packages',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardMetricsRoute = AuthDashboardMetricsImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardMealsRoute = AuthDashboardMealsImport.update({
  id: '/meals',
  path: '/meals',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardHabitsRoute = AuthDashboardHabitsImport.update({
  id: '/habits',
  path: '/habits',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardGettingStartedRoute =
  AuthDashboardGettingStartedImport.update({
    id: '/getting-started',
    path: '/getting-started',
    getParentRoute: () => AuthDashboardRoute,
  } as any)

const AuthDashboardFoodsRoute = AuthDashboardFoodsImport.update({
  id: '/foods',
  path: '/foods',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardExercisesRoute = AuthDashboardExercisesImport.update({
  id: '/exercises',
  path: '/exercises',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardDashboardRoute = AuthDashboardDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardCheckinsRoute = AuthDashboardCheckinsImport.update({
  id: '/checkins',
  path: '/checkins',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardChatRoute = AuthDashboardChatImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardBrandingRoute = AuthDashboardBrandingImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardClientsClientIdRoute =
  AuthDashboardClientsClientIdImport.update({
    id: '/clients/$clientId',
    path: '/clients/$clientId',
    getParentRoute: () => AuthDashboardRoute,
  } as any)

const AuthDashboardWorkoutsIndexRoute = AuthDashboardWorkoutsIndexImport.update(
  {
    id: '/workouts/',
    path: '/workouts/',
    getParentRoute: () => AuthDashboardRoute,
  } as any,
)

const AuthDashboardTrainingIndexRoute = AuthDashboardTrainingIndexImport.update(
  {
    id: '/training/',
    path: '/training/',
    getParentRoute: () => AuthDashboardRoute,
  } as any,
)

const AuthDashboardNutritionIndexRoute =
  AuthDashboardNutritionIndexImport.update({
    id: '/nutrition/',
    path: '/nutrition/',
    getParentRoute: () => AuthDashboardRoute,
  } as any)

const AuthDashboardLeadsIndexRoute = AuthDashboardLeadsIndexImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardFormsIndexRoute = AuthDashboardFormsIndexImport.update({
  id: '/forms/',
  path: '/forms/',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardClientsIndexRoute = AuthDashboardClientsIndexImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardWorkoutsWorkoutIdRoute =
  AuthDashboardWorkoutsWorkoutIdImport.update({
    id: '/workouts/$workoutId',
    path: '/workouts/$workoutId',
    getParentRoute: () => AuthDashboardRoute,
  } as any)

const AuthDashboardTrainingTemplateIdRoute =
  AuthDashboardTrainingTemplateIdImport.update({
    id: '/training/$templateId',
    path: '/training/$templateId',
    getParentRoute: () => AuthDashboardRoute,
  } as any)

const AuthDashboardSettingsLayoutRoute =
  AuthDashboardSettingsLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthDashboardSettingsRoute,
  } as any)

const AuthDashboardNutritionTemplateIdRoute =
  AuthDashboardNutritionTemplateIdImport.update({
    id: '/nutrition/$templateId',
    path: '/nutrition/$templateId',
    getParentRoute: () => AuthDashboardRoute,
  } as any)

const AuthDashboardLeadsLeadIdRoute = AuthDashboardLeadsLeadIdImport.update({
  id: '/leads/$leadId',
  path: '/leads/$leadId',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardFormsFormIdRoute = AuthDashboardFormsFormIdImport.update({
  id: '/forms/$formId',
  path: '/forms/$formId',
  getParentRoute: () => AuthDashboardRoute,
} as any)

const AuthDashboardSettingsLayoutIndexRoute =
  AuthDashboardSettingsLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDashboardSettingsLayoutRoute,
  } as any)

const AuthDashboardSettingsLayoutSubscriptionRoute =
  AuthDashboardSettingsLayoutSubscriptionImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthDashboardSettingsLayoutRoute,
  } as any)

const AuthDashboardSettingsLayoutSecurityRoute =
  AuthDashboardSettingsLayoutSecurityImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthDashboardSettingsLayoutRoute,
  } as any)

const AuthDashboardSettingsLayoutOrganisationRoute =
  AuthDashboardSettingsLayoutOrganisationImport.update({
    id: '/organisation',
    path: '/organisation',
    getParentRoute: () => AuthDashboardSettingsLayoutRoute,
  } as any)

const AuthDashboardClientsClientIdLayoutRoute =
  AuthDashboardClientsClientIdLayoutImport.update({
    id: '/_layout',
    getParentRoute: () => AuthDashboardClientsClientIdRoute,
  } as any)

const AuthDashboardClientsClientIdLayoutIndexRoute =
  AuthDashboardClientsClientIdLayoutIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)

const AuthDashboardClientsClientIdLayoutVaultRoute =
  AuthDashboardClientsClientIdLayoutVaultImport.update({
    id: '/vault',
    path: '/vault',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)

const AuthDashboardClientsClientIdLayoutTrainingRoute =
  AuthDashboardClientsClientIdLayoutTrainingImport.update({
    id: '/training',
    path: '/training',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)

const AuthDashboardClientsClientIdLayoutSettingsRoute =
  AuthDashboardClientsClientIdLayoutSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)

const AuthDashboardClientsClientIdLayoutRoadmapRoute =
  AuthDashboardClientsClientIdLayoutRoadmapImport.update({
    id: '/roadmap',
    path: '/roadmap',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)

const AuthDashboardClientsClientIdLayoutNutritionRoute =
  AuthDashboardClientsClientIdLayoutNutritionImport.update({
    id: '/nutrition',
    path: '/nutrition',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)

const AuthDashboardClientsClientIdLayoutMetricsRoute =
  AuthDashboardClientsClientIdLayoutMetricsImport.update({
    id: '/metrics',
    path: '/metrics',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)

const AuthDashboardClientsClientIdLayoutHabitsRoute =
  AuthDashboardClientsClientIdLayoutHabitsImport.update({
    id: '/habits',
    path: '/habits',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)

const AuthDashboardClientsClientIdLayoutGalleryRoute =
  AuthDashboardClientsClientIdLayoutGalleryImport.update({
    id: '/gallery',
    path: '/gallery',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)

const AuthDashboardClientsClientIdLayoutActivityRoute =
  AuthDashboardClientsClientIdLayoutActivityImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)

const AuthDashboardClientsClientIdLayoutCheckinIndexRoute =
  AuthDashboardClientsClientIdLayoutCheckinIndexImport.update({
    id: '/checkin/',
    path: '/checkin/',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)

const AuthDashboardClientsClientIdLayoutCheckinCompareRoute =
  AuthDashboardClientsClientIdLayoutCheckinCompareImport.update({
    id: '/checkin/compare',
    path: '/checkin/compare',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)

const AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute =
  AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdImport.update({
    id: '/checkin/$formId/$responseId',
    path: '/checkin/$formId/$responseId',
    getParentRoute: () => AuthDashboardClientsClientIdLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinImport
      parentRoute: typeof rootRoute
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/(setup)/setup': {
      id: '/(setup)/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof setupSetupImport
      parentRoute: typeof rootRoute
    }
    '/(unauth)/forgot': {
      id: '/(unauth)/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof unauthForgotImport
      parentRoute: typeof rootRoute
    }
    '/(unauth)/login': {
      id: '/(unauth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof unauthLoginImport
      parentRoute: typeof rootRoute
    }
    '/(unauth)/register': {
      id: '/(unauth)/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof unauthRegisterImport
      parentRoute: typeof rootRoute
    }
    '/_auth/_dashboard': {
      id: '/_auth/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthDashboardImport
      parentRoute: typeof AuthImport
    }
    '/_auth/workout-session': {
      id: '/_auth/workout-session'
      path: '/workout-session'
      fullPath: '/workout-session'
      preLoaderRoute: typeof AuthWorkoutSessionImport
      parentRoute: typeof AuthImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackImport
      parentRoute: typeof rootRoute
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentImport
      parentRoute: typeof rootRoute
    }
    '/_auth/_dashboard/branding': {
      id: '/_auth/_dashboard/branding'
      path: '/branding'
      fullPath: '/branding'
      preLoaderRoute: typeof AuthDashboardBrandingImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/chat': {
      id: '/_auth/_dashboard/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AuthDashboardChatImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/checkins': {
      id: '/_auth/_dashboard/checkins'
      path: '/checkins'
      fullPath: '/checkins'
      preLoaderRoute: typeof AuthDashboardCheckinsImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/dashboard': {
      id: '/_auth/_dashboard/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardDashboardImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/exercises': {
      id: '/_auth/_dashboard/exercises'
      path: '/exercises'
      fullPath: '/exercises'
      preLoaderRoute: typeof AuthDashboardExercisesImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/foods': {
      id: '/_auth/_dashboard/foods'
      path: '/foods'
      fullPath: '/foods'
      preLoaderRoute: typeof AuthDashboardFoodsImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/getting-started': {
      id: '/_auth/_dashboard/getting-started'
      path: '/getting-started'
      fullPath: '/getting-started'
      preLoaderRoute: typeof AuthDashboardGettingStartedImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/habits': {
      id: '/_auth/_dashboard/habits'
      path: '/habits'
      fullPath: '/habits'
      preLoaderRoute: typeof AuthDashboardHabitsImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/meals': {
      id: '/_auth/_dashboard/meals'
      path: '/meals'
      fullPath: '/meals'
      preLoaderRoute: typeof AuthDashboardMealsImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/metrics': {
      id: '/_auth/_dashboard/metrics'
      path: '/metrics'
      fullPath: '/metrics'
      preLoaderRoute: typeof AuthDashboardMetricsImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/packages': {
      id: '/_auth/_dashboard/packages'
      path: '/packages'
      fullPath: '/packages'
      preLoaderRoute: typeof AuthDashboardPackagesImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/refer': {
      id: '/_auth/_dashboard/refer'
      path: '/refer'
      fullPath: '/refer'
      preLoaderRoute: typeof AuthDashboardReferImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/supplements': {
      id: '/_auth/_dashboard/supplements'
      path: '/supplements'
      fullPath: '/supplements'
      preLoaderRoute: typeof AuthDashboardSupplementsImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/team': {
      id: '/_auth/_dashboard/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AuthDashboardTeamImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/upgrade': {
      id: '/_auth/_dashboard/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof AuthDashboardUpgradeImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/vault': {
      id: '/_auth/_dashboard/vault'
      path: '/vault'
      fullPath: '/vault'
      preLoaderRoute: typeof AuthDashboardVaultImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/forms/$formId': {
      id: '/_auth/_dashboard/forms/$formId'
      path: '/forms/$formId'
      fullPath: '/forms/$formId'
      preLoaderRoute: typeof AuthDashboardFormsFormIdImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/leads/$leadId': {
      id: '/_auth/_dashboard/leads/$leadId'
      path: '/leads/$leadId'
      fullPath: '/leads/$leadId'
      preLoaderRoute: typeof AuthDashboardLeadsLeadIdImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/nutrition/$templateId': {
      id: '/_auth/_dashboard/nutrition/$templateId'
      path: '/nutrition/$templateId'
      fullPath: '/nutrition/$templateId'
      preLoaderRoute: typeof AuthDashboardNutritionTemplateIdImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/settings': {
      id: '/_auth/_dashboard/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthDashboardSettingsImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/settings/_layout': {
      id: '/_auth/_dashboard/settings/_layout'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthDashboardSettingsLayoutImport
      parentRoute: typeof AuthDashboardSettingsRoute
    }
    '/_auth/_dashboard/training/$templateId': {
      id: '/_auth/_dashboard/training/$templateId'
      path: '/training/$templateId'
      fullPath: '/training/$templateId'
      preLoaderRoute: typeof AuthDashboardTrainingTemplateIdImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/workouts/$workoutId': {
      id: '/_auth/_dashboard/workouts/$workoutId'
      path: '/workouts/$workoutId'
      fullPath: '/workouts/$workoutId'
      preLoaderRoute: typeof AuthDashboardWorkoutsWorkoutIdImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/clients/': {
      id: '/_auth/_dashboard/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AuthDashboardClientsIndexImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/forms/': {
      id: '/_auth/_dashboard/forms/'
      path: '/forms'
      fullPath: '/forms'
      preLoaderRoute: typeof AuthDashboardFormsIndexImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/leads/': {
      id: '/_auth/_dashboard/leads/'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof AuthDashboardLeadsIndexImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/nutrition/': {
      id: '/_auth/_dashboard/nutrition/'
      path: '/nutrition'
      fullPath: '/nutrition'
      preLoaderRoute: typeof AuthDashboardNutritionIndexImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/training/': {
      id: '/_auth/_dashboard/training/'
      path: '/training'
      fullPath: '/training'
      preLoaderRoute: typeof AuthDashboardTrainingIndexImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/workouts/': {
      id: '/_auth/_dashboard/workouts/'
      path: '/workouts'
      fullPath: '/workouts'
      preLoaderRoute: typeof AuthDashboardWorkoutsIndexImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/clients/$clientId': {
      id: '/_auth/_dashboard/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AuthDashboardClientsClientIdImport
      parentRoute: typeof AuthDashboardImport
    }
    '/_auth/_dashboard/clients/$clientId/_layout': {
      id: '/_auth/_dashboard/clients/$clientId/_layout'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutImport
      parentRoute: typeof AuthDashboardClientsClientIdRoute
    }
    '/_auth/_dashboard/settings/_layout/organisation': {
      id: '/_auth/_dashboard/settings/_layout/organisation'
      path: '/organisation'
      fullPath: '/settings/organisation'
      preLoaderRoute: typeof AuthDashboardSettingsLayoutOrganisationImport
      parentRoute: typeof AuthDashboardSettingsLayoutImport
    }
    '/_auth/_dashboard/settings/_layout/security': {
      id: '/_auth/_dashboard/settings/_layout/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthDashboardSettingsLayoutSecurityImport
      parentRoute: typeof AuthDashboardSettingsLayoutImport
    }
    '/_auth/_dashboard/settings/_layout/subscription': {
      id: '/_auth/_dashboard/settings/_layout/subscription'
      path: '/subscription'
      fullPath: '/settings/subscription'
      preLoaderRoute: typeof AuthDashboardSettingsLayoutSubscriptionImport
      parentRoute: typeof AuthDashboardSettingsLayoutImport
    }
    '/_auth/_dashboard/settings/_layout/': {
      id: '/_auth/_dashboard/settings/_layout/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthDashboardSettingsLayoutIndexImport
      parentRoute: typeof AuthDashboardSettingsLayoutImport
    }
    '/_auth/_dashboard/clients/$clientId/_layout/activity': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/activity'
      path: '/activity'
      fullPath: '/clients/$clientId/activity'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutActivityImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutImport
    }
    '/_auth/_dashboard/clients/$clientId/_layout/gallery': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/gallery'
      path: '/gallery'
      fullPath: '/clients/$clientId/gallery'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutGalleryImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutImport
    }
    '/_auth/_dashboard/clients/$clientId/_layout/habits': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/habits'
      path: '/habits'
      fullPath: '/clients/$clientId/habits'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutHabitsImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutImport
    }
    '/_auth/_dashboard/clients/$clientId/_layout/metrics': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/metrics'
      path: '/metrics'
      fullPath: '/clients/$clientId/metrics'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutMetricsImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutImport
    }
    '/_auth/_dashboard/clients/$clientId/_layout/nutrition': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/nutrition'
      path: '/nutrition'
      fullPath: '/clients/$clientId/nutrition'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutNutritionImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutImport
    }
    '/_auth/_dashboard/clients/$clientId/_layout/roadmap': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/roadmap'
      path: '/roadmap'
      fullPath: '/clients/$clientId/roadmap'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutRoadmapImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutImport
    }
    '/_auth/_dashboard/clients/$clientId/_layout/settings': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/settings'
      path: '/settings'
      fullPath: '/clients/$clientId/settings'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutSettingsImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutImport
    }
    '/_auth/_dashboard/clients/$clientId/_layout/training': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/training'
      path: '/training'
      fullPath: '/clients/$clientId/training'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutTrainingImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutImport
    }
    '/_auth/_dashboard/clients/$clientId/_layout/vault': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/vault'
      path: '/vault'
      fullPath: '/clients/$clientId/vault'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutVaultImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutImport
    }
    '/_auth/_dashboard/clients/$clientId/_layout/': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/'
      path: '/'
      fullPath: '/clients/$clientId/'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutIndexImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutImport
    }
    '/_auth/_dashboard/clients/$clientId/_layout/checkin/compare': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/checkin/compare'
      path: '/checkin/compare'
      fullPath: '/clients/$clientId/checkin/compare'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutCheckinCompareImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutImport
    }
    '/_auth/_dashboard/clients/$clientId/_layout/checkin/': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/checkin/'
      path: '/checkin'
      fullPath: '/clients/$clientId/checkin'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutCheckinIndexImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutImport
    }
    '/_auth/_dashboard/clients/$clientId/_layout/checkin/$formId/$responseId': {
      id: '/_auth/_dashboard/clients/$clientId/_layout/checkin/$formId/$responseId'
      path: '/checkin/$formId/$responseId'
      fullPath: '/clients/$clientId/checkin/$formId/$responseId'
      preLoaderRoute: typeof AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdImport
      parentRoute: typeof AuthDashboardClientsClientIdLayoutImport
    }
  }
}

// Create and export the route tree

interface AuthDashboardSettingsLayoutRouteChildren {
  AuthDashboardSettingsLayoutOrganisationRoute: typeof AuthDashboardSettingsLayoutOrganisationRoute
  AuthDashboardSettingsLayoutSecurityRoute: typeof AuthDashboardSettingsLayoutSecurityRoute
  AuthDashboardSettingsLayoutSubscriptionRoute: typeof AuthDashboardSettingsLayoutSubscriptionRoute
  AuthDashboardSettingsLayoutIndexRoute: typeof AuthDashboardSettingsLayoutIndexRoute
}

const AuthDashboardSettingsLayoutRouteChildren: AuthDashboardSettingsLayoutRouteChildren =
  {
    AuthDashboardSettingsLayoutOrganisationRoute:
      AuthDashboardSettingsLayoutOrganisationRoute,
    AuthDashboardSettingsLayoutSecurityRoute:
      AuthDashboardSettingsLayoutSecurityRoute,
    AuthDashboardSettingsLayoutSubscriptionRoute:
      AuthDashboardSettingsLayoutSubscriptionRoute,
    AuthDashboardSettingsLayoutIndexRoute:
      AuthDashboardSettingsLayoutIndexRoute,
  }

const AuthDashboardSettingsLayoutRouteWithChildren =
  AuthDashboardSettingsLayoutRoute._addFileChildren(
    AuthDashboardSettingsLayoutRouteChildren,
  )

interface AuthDashboardSettingsRouteChildren {
  AuthDashboardSettingsLayoutRoute: typeof AuthDashboardSettingsLayoutRouteWithChildren
}

const AuthDashboardSettingsRouteChildren: AuthDashboardSettingsRouteChildren = {
  AuthDashboardSettingsLayoutRoute:
    AuthDashboardSettingsLayoutRouteWithChildren,
}

const AuthDashboardSettingsRouteWithChildren =
  AuthDashboardSettingsRoute._addFileChildren(
    AuthDashboardSettingsRouteChildren,
  )

interface AuthDashboardClientsClientIdLayoutRouteChildren {
  AuthDashboardClientsClientIdLayoutActivityRoute: typeof AuthDashboardClientsClientIdLayoutActivityRoute
  AuthDashboardClientsClientIdLayoutGalleryRoute: typeof AuthDashboardClientsClientIdLayoutGalleryRoute
  AuthDashboardClientsClientIdLayoutHabitsRoute: typeof AuthDashboardClientsClientIdLayoutHabitsRoute
  AuthDashboardClientsClientIdLayoutMetricsRoute: typeof AuthDashboardClientsClientIdLayoutMetricsRoute
  AuthDashboardClientsClientIdLayoutNutritionRoute: typeof AuthDashboardClientsClientIdLayoutNutritionRoute
  AuthDashboardClientsClientIdLayoutRoadmapRoute: typeof AuthDashboardClientsClientIdLayoutRoadmapRoute
  AuthDashboardClientsClientIdLayoutSettingsRoute: typeof AuthDashboardClientsClientIdLayoutSettingsRoute
  AuthDashboardClientsClientIdLayoutTrainingRoute: typeof AuthDashboardClientsClientIdLayoutTrainingRoute
  AuthDashboardClientsClientIdLayoutVaultRoute: typeof AuthDashboardClientsClientIdLayoutVaultRoute
  AuthDashboardClientsClientIdLayoutIndexRoute: typeof AuthDashboardClientsClientIdLayoutIndexRoute
  AuthDashboardClientsClientIdLayoutCheckinCompareRoute: typeof AuthDashboardClientsClientIdLayoutCheckinCompareRoute
  AuthDashboardClientsClientIdLayoutCheckinIndexRoute: typeof AuthDashboardClientsClientIdLayoutCheckinIndexRoute
  AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute: typeof AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute
}

const AuthDashboardClientsClientIdLayoutRouteChildren: AuthDashboardClientsClientIdLayoutRouteChildren =
  {
    AuthDashboardClientsClientIdLayoutActivityRoute:
      AuthDashboardClientsClientIdLayoutActivityRoute,
    AuthDashboardClientsClientIdLayoutGalleryRoute:
      AuthDashboardClientsClientIdLayoutGalleryRoute,
    AuthDashboardClientsClientIdLayoutHabitsRoute:
      AuthDashboardClientsClientIdLayoutHabitsRoute,
    AuthDashboardClientsClientIdLayoutMetricsRoute:
      AuthDashboardClientsClientIdLayoutMetricsRoute,
    AuthDashboardClientsClientIdLayoutNutritionRoute:
      AuthDashboardClientsClientIdLayoutNutritionRoute,
    AuthDashboardClientsClientIdLayoutRoadmapRoute:
      AuthDashboardClientsClientIdLayoutRoadmapRoute,
    AuthDashboardClientsClientIdLayoutSettingsRoute:
      AuthDashboardClientsClientIdLayoutSettingsRoute,
    AuthDashboardClientsClientIdLayoutTrainingRoute:
      AuthDashboardClientsClientIdLayoutTrainingRoute,
    AuthDashboardClientsClientIdLayoutVaultRoute:
      AuthDashboardClientsClientIdLayoutVaultRoute,
    AuthDashboardClientsClientIdLayoutIndexRoute:
      AuthDashboardClientsClientIdLayoutIndexRoute,
    AuthDashboardClientsClientIdLayoutCheckinCompareRoute:
      AuthDashboardClientsClientIdLayoutCheckinCompareRoute,
    AuthDashboardClientsClientIdLayoutCheckinIndexRoute:
      AuthDashboardClientsClientIdLayoutCheckinIndexRoute,
    AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute:
      AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute,
  }

const AuthDashboardClientsClientIdLayoutRouteWithChildren =
  AuthDashboardClientsClientIdLayoutRoute._addFileChildren(
    AuthDashboardClientsClientIdLayoutRouteChildren,
  )

interface AuthDashboardClientsClientIdRouteChildren {
  AuthDashboardClientsClientIdLayoutRoute: typeof AuthDashboardClientsClientIdLayoutRouteWithChildren
}

const AuthDashboardClientsClientIdRouteChildren: AuthDashboardClientsClientIdRouteChildren =
  {
    AuthDashboardClientsClientIdLayoutRoute:
      AuthDashboardClientsClientIdLayoutRouteWithChildren,
  }

const AuthDashboardClientsClientIdRouteWithChildren =
  AuthDashboardClientsClientIdRoute._addFileChildren(
    AuthDashboardClientsClientIdRouteChildren,
  )

interface AuthDashboardRouteChildren {
  AuthDashboardBrandingRoute: typeof AuthDashboardBrandingRoute
  AuthDashboardChatRoute: typeof AuthDashboardChatRoute
  AuthDashboardCheckinsRoute: typeof AuthDashboardCheckinsRoute
  AuthDashboardDashboardRoute: typeof AuthDashboardDashboardRoute
  AuthDashboardExercisesRoute: typeof AuthDashboardExercisesRoute
  AuthDashboardFoodsRoute: typeof AuthDashboardFoodsRoute
  AuthDashboardGettingStartedRoute: typeof AuthDashboardGettingStartedRoute
  AuthDashboardHabitsRoute: typeof AuthDashboardHabitsRoute
  AuthDashboardMealsRoute: typeof AuthDashboardMealsRoute
  AuthDashboardMetricsRoute: typeof AuthDashboardMetricsRoute
  AuthDashboardPackagesRoute: typeof AuthDashboardPackagesRoute
  AuthDashboardReferRoute: typeof AuthDashboardReferRoute
  AuthDashboardSupplementsRoute: typeof AuthDashboardSupplementsRoute
  AuthDashboardTeamRoute: typeof AuthDashboardTeamRoute
  AuthDashboardUpgradeRoute: typeof AuthDashboardUpgradeRoute
  AuthDashboardVaultRoute: typeof AuthDashboardVaultRoute
  AuthDashboardFormsFormIdRoute: typeof AuthDashboardFormsFormIdRoute
  AuthDashboardLeadsLeadIdRoute: typeof AuthDashboardLeadsLeadIdRoute
  AuthDashboardNutritionTemplateIdRoute: typeof AuthDashboardNutritionTemplateIdRoute
  AuthDashboardSettingsRoute: typeof AuthDashboardSettingsRouteWithChildren
  AuthDashboardTrainingTemplateIdRoute: typeof AuthDashboardTrainingTemplateIdRoute
  AuthDashboardWorkoutsWorkoutIdRoute: typeof AuthDashboardWorkoutsWorkoutIdRoute
  AuthDashboardClientsIndexRoute: typeof AuthDashboardClientsIndexRoute
  AuthDashboardFormsIndexRoute: typeof AuthDashboardFormsIndexRoute
  AuthDashboardLeadsIndexRoute: typeof AuthDashboardLeadsIndexRoute
  AuthDashboardNutritionIndexRoute: typeof AuthDashboardNutritionIndexRoute
  AuthDashboardTrainingIndexRoute: typeof AuthDashboardTrainingIndexRoute
  AuthDashboardWorkoutsIndexRoute: typeof AuthDashboardWorkoutsIndexRoute
  AuthDashboardClientsClientIdRoute: typeof AuthDashboardClientsClientIdRouteWithChildren
}

const AuthDashboardRouteChildren: AuthDashboardRouteChildren = {
  AuthDashboardBrandingRoute: AuthDashboardBrandingRoute,
  AuthDashboardChatRoute: AuthDashboardChatRoute,
  AuthDashboardCheckinsRoute: AuthDashboardCheckinsRoute,
  AuthDashboardDashboardRoute: AuthDashboardDashboardRoute,
  AuthDashboardExercisesRoute: AuthDashboardExercisesRoute,
  AuthDashboardFoodsRoute: AuthDashboardFoodsRoute,
  AuthDashboardGettingStartedRoute: AuthDashboardGettingStartedRoute,
  AuthDashboardHabitsRoute: AuthDashboardHabitsRoute,
  AuthDashboardMealsRoute: AuthDashboardMealsRoute,
  AuthDashboardMetricsRoute: AuthDashboardMetricsRoute,
  AuthDashboardPackagesRoute: AuthDashboardPackagesRoute,
  AuthDashboardReferRoute: AuthDashboardReferRoute,
  AuthDashboardSupplementsRoute: AuthDashboardSupplementsRoute,
  AuthDashboardTeamRoute: AuthDashboardTeamRoute,
  AuthDashboardUpgradeRoute: AuthDashboardUpgradeRoute,
  AuthDashboardVaultRoute: AuthDashboardVaultRoute,
  AuthDashboardFormsFormIdRoute: AuthDashboardFormsFormIdRoute,
  AuthDashboardLeadsLeadIdRoute: AuthDashboardLeadsLeadIdRoute,
  AuthDashboardNutritionTemplateIdRoute: AuthDashboardNutritionTemplateIdRoute,
  AuthDashboardSettingsRoute: AuthDashboardSettingsRouteWithChildren,
  AuthDashboardTrainingTemplateIdRoute: AuthDashboardTrainingTemplateIdRoute,
  AuthDashboardWorkoutsWorkoutIdRoute: AuthDashboardWorkoutsWorkoutIdRoute,
  AuthDashboardClientsIndexRoute: AuthDashboardClientsIndexRoute,
  AuthDashboardFormsIndexRoute: AuthDashboardFormsIndexRoute,
  AuthDashboardLeadsIndexRoute: AuthDashboardLeadsIndexRoute,
  AuthDashboardNutritionIndexRoute: AuthDashboardNutritionIndexRoute,
  AuthDashboardTrainingIndexRoute: AuthDashboardTrainingIndexRoute,
  AuthDashboardWorkoutsIndexRoute: AuthDashboardWorkoutsIndexRoute,
  AuthDashboardClientsClientIdRoute:
    AuthDashboardClientsClientIdRouteWithChildren,
}

const AuthDashboardRouteWithChildren = AuthDashboardRoute._addFileChildren(
  AuthDashboardRouteChildren,
)

interface AuthRouteChildren {
  AuthDashboardRoute: typeof AuthDashboardRouteWithChildren
  AuthWorkoutSessionRoute: typeof AuthWorkoutSessionRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthDashboardRoute: AuthDashboardRouteWithChildren,
  AuthWorkoutSessionRoute: AuthWorkoutSessionRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthDashboardRouteWithChildren
  '/join': typeof JoinRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup': typeof setupSetupRoute
  '/forgot': typeof unauthForgotRoute
  '/login': typeof unauthLoginRoute
  '/register': typeof unauthRegisterRoute
  '/workout-session': typeof AuthWorkoutSessionRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/branding': typeof AuthDashboardBrandingRoute
  '/chat': typeof AuthDashboardChatRoute
  '/checkins': typeof AuthDashboardCheckinsRoute
  '/dashboard': typeof AuthDashboardDashboardRoute
  '/exercises': typeof AuthDashboardExercisesRoute
  '/foods': typeof AuthDashboardFoodsRoute
  '/getting-started': typeof AuthDashboardGettingStartedRoute
  '/habits': typeof AuthDashboardHabitsRoute
  '/meals': typeof AuthDashboardMealsRoute
  '/metrics': typeof AuthDashboardMetricsRoute
  '/packages': typeof AuthDashboardPackagesRoute
  '/refer': typeof AuthDashboardReferRoute
  '/supplements': typeof AuthDashboardSupplementsRoute
  '/team': typeof AuthDashboardTeamRoute
  '/upgrade': typeof AuthDashboardUpgradeRoute
  '/vault': typeof AuthDashboardVaultRoute
  '/forms/$formId': typeof AuthDashboardFormsFormIdRoute
  '/leads/$leadId': typeof AuthDashboardLeadsLeadIdRoute
  '/nutrition/$templateId': typeof AuthDashboardNutritionTemplateIdRoute
  '/settings': typeof AuthDashboardSettingsLayoutRouteWithChildren
  '/training/$templateId': typeof AuthDashboardTrainingTemplateIdRoute
  '/workouts/$workoutId': typeof AuthDashboardWorkoutsWorkoutIdRoute
  '/clients': typeof AuthDashboardClientsIndexRoute
  '/forms': typeof AuthDashboardFormsIndexRoute
  '/leads': typeof AuthDashboardLeadsIndexRoute
  '/nutrition': typeof AuthDashboardNutritionIndexRoute
  '/training': typeof AuthDashboardTrainingIndexRoute
  '/workouts': typeof AuthDashboardWorkoutsIndexRoute
  '/clients/$clientId': typeof AuthDashboardClientsClientIdLayoutRouteWithChildren
  '/settings/organisation': typeof AuthDashboardSettingsLayoutOrganisationRoute
  '/settings/security': typeof AuthDashboardSettingsLayoutSecurityRoute
  '/settings/subscription': typeof AuthDashboardSettingsLayoutSubscriptionRoute
  '/settings/': typeof AuthDashboardSettingsLayoutIndexRoute
  '/clients/$clientId/activity': typeof AuthDashboardClientsClientIdLayoutActivityRoute
  '/clients/$clientId/gallery': typeof AuthDashboardClientsClientIdLayoutGalleryRoute
  '/clients/$clientId/habits': typeof AuthDashboardClientsClientIdLayoutHabitsRoute
  '/clients/$clientId/metrics': typeof AuthDashboardClientsClientIdLayoutMetricsRoute
  '/clients/$clientId/nutrition': typeof AuthDashboardClientsClientIdLayoutNutritionRoute
  '/clients/$clientId/roadmap': typeof AuthDashboardClientsClientIdLayoutRoadmapRoute
  '/clients/$clientId/settings': typeof AuthDashboardClientsClientIdLayoutSettingsRoute
  '/clients/$clientId/training': typeof AuthDashboardClientsClientIdLayoutTrainingRoute
  '/clients/$clientId/vault': typeof AuthDashboardClientsClientIdLayoutVaultRoute
  '/clients/$clientId/': typeof AuthDashboardClientsClientIdLayoutIndexRoute
  '/clients/$clientId/checkin/compare': typeof AuthDashboardClientsClientIdLayoutCheckinCompareRoute
  '/clients/$clientId/checkin': typeof AuthDashboardClientsClientIdLayoutCheckinIndexRoute
  '/clients/$clientId/checkin/$formId/$responseId': typeof AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthDashboardRouteWithChildren
  '/join': typeof JoinRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup': typeof setupSetupRoute
  '/forgot': typeof unauthForgotRoute
  '/login': typeof unauthLoginRoute
  '/register': typeof unauthRegisterRoute
  '/workout-session': typeof AuthWorkoutSessionRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/branding': typeof AuthDashboardBrandingRoute
  '/chat': typeof AuthDashboardChatRoute
  '/checkins': typeof AuthDashboardCheckinsRoute
  '/dashboard': typeof AuthDashboardDashboardRoute
  '/exercises': typeof AuthDashboardExercisesRoute
  '/foods': typeof AuthDashboardFoodsRoute
  '/getting-started': typeof AuthDashboardGettingStartedRoute
  '/habits': typeof AuthDashboardHabitsRoute
  '/meals': typeof AuthDashboardMealsRoute
  '/metrics': typeof AuthDashboardMetricsRoute
  '/packages': typeof AuthDashboardPackagesRoute
  '/refer': typeof AuthDashboardReferRoute
  '/supplements': typeof AuthDashboardSupplementsRoute
  '/team': typeof AuthDashboardTeamRoute
  '/upgrade': typeof AuthDashboardUpgradeRoute
  '/vault': typeof AuthDashboardVaultRoute
  '/forms/$formId': typeof AuthDashboardFormsFormIdRoute
  '/leads/$leadId': typeof AuthDashboardLeadsLeadIdRoute
  '/nutrition/$templateId': typeof AuthDashboardNutritionTemplateIdRoute
  '/settings': typeof AuthDashboardSettingsLayoutIndexRoute
  '/training/$templateId': typeof AuthDashboardTrainingTemplateIdRoute
  '/workouts/$workoutId': typeof AuthDashboardWorkoutsWorkoutIdRoute
  '/clients': typeof AuthDashboardClientsIndexRoute
  '/forms': typeof AuthDashboardFormsIndexRoute
  '/leads': typeof AuthDashboardLeadsIndexRoute
  '/nutrition': typeof AuthDashboardNutritionIndexRoute
  '/training': typeof AuthDashboardTrainingIndexRoute
  '/workouts': typeof AuthDashboardWorkoutsIndexRoute
  '/clients/$clientId': typeof AuthDashboardClientsClientIdLayoutIndexRoute
  '/settings/organisation': typeof AuthDashboardSettingsLayoutOrganisationRoute
  '/settings/security': typeof AuthDashboardSettingsLayoutSecurityRoute
  '/settings/subscription': typeof AuthDashboardSettingsLayoutSubscriptionRoute
  '/clients/$clientId/activity': typeof AuthDashboardClientsClientIdLayoutActivityRoute
  '/clients/$clientId/gallery': typeof AuthDashboardClientsClientIdLayoutGalleryRoute
  '/clients/$clientId/habits': typeof AuthDashboardClientsClientIdLayoutHabitsRoute
  '/clients/$clientId/metrics': typeof AuthDashboardClientsClientIdLayoutMetricsRoute
  '/clients/$clientId/nutrition': typeof AuthDashboardClientsClientIdLayoutNutritionRoute
  '/clients/$clientId/roadmap': typeof AuthDashboardClientsClientIdLayoutRoadmapRoute
  '/clients/$clientId/settings': typeof AuthDashboardClientsClientIdLayoutSettingsRoute
  '/clients/$clientId/training': typeof AuthDashboardClientsClientIdLayoutTrainingRoute
  '/clients/$clientId/vault': typeof AuthDashboardClientsClientIdLayoutVaultRoute
  '/clients/$clientId/checkin/compare': typeof AuthDashboardClientsClientIdLayoutCheckinCompareRoute
  '/clients/$clientId/checkin': typeof AuthDashboardClientsClientIdLayoutCheckinIndexRoute
  '/clients/$clientId/checkin/$formId/$responseId': typeof AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/join': typeof JoinRoute
  '/reset-password': typeof ResetPasswordRoute
  '/(setup)/setup': typeof setupSetupRoute
  '/(unauth)/forgot': typeof unauthForgotRoute
  '/(unauth)/login': typeof unauthLoginRoute
  '/(unauth)/register': typeof unauthRegisterRoute
  '/_auth/_dashboard': typeof AuthDashboardRouteWithChildren
  '/_auth/workout-session': typeof AuthWorkoutSessionRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/_auth/_dashboard/branding': typeof AuthDashboardBrandingRoute
  '/_auth/_dashboard/chat': typeof AuthDashboardChatRoute
  '/_auth/_dashboard/checkins': typeof AuthDashboardCheckinsRoute
  '/_auth/_dashboard/dashboard': typeof AuthDashboardDashboardRoute
  '/_auth/_dashboard/exercises': typeof AuthDashboardExercisesRoute
  '/_auth/_dashboard/foods': typeof AuthDashboardFoodsRoute
  '/_auth/_dashboard/getting-started': typeof AuthDashboardGettingStartedRoute
  '/_auth/_dashboard/habits': typeof AuthDashboardHabitsRoute
  '/_auth/_dashboard/meals': typeof AuthDashboardMealsRoute
  '/_auth/_dashboard/metrics': typeof AuthDashboardMetricsRoute
  '/_auth/_dashboard/packages': typeof AuthDashboardPackagesRoute
  '/_auth/_dashboard/refer': typeof AuthDashboardReferRoute
  '/_auth/_dashboard/supplements': typeof AuthDashboardSupplementsRoute
  '/_auth/_dashboard/team': typeof AuthDashboardTeamRoute
  '/_auth/_dashboard/upgrade': typeof AuthDashboardUpgradeRoute
  '/_auth/_dashboard/vault': typeof AuthDashboardVaultRoute
  '/_auth/_dashboard/forms/$formId': typeof AuthDashboardFormsFormIdRoute
  '/_auth/_dashboard/leads/$leadId': typeof AuthDashboardLeadsLeadIdRoute
  '/_auth/_dashboard/nutrition/$templateId': typeof AuthDashboardNutritionTemplateIdRoute
  '/_auth/_dashboard/settings': typeof AuthDashboardSettingsRouteWithChildren
  '/_auth/_dashboard/settings/_layout': typeof AuthDashboardSettingsLayoutRouteWithChildren
  '/_auth/_dashboard/training/$templateId': typeof AuthDashboardTrainingTemplateIdRoute
  '/_auth/_dashboard/workouts/$workoutId': typeof AuthDashboardWorkoutsWorkoutIdRoute
  '/_auth/_dashboard/clients/': typeof AuthDashboardClientsIndexRoute
  '/_auth/_dashboard/forms/': typeof AuthDashboardFormsIndexRoute
  '/_auth/_dashboard/leads/': typeof AuthDashboardLeadsIndexRoute
  '/_auth/_dashboard/nutrition/': typeof AuthDashboardNutritionIndexRoute
  '/_auth/_dashboard/training/': typeof AuthDashboardTrainingIndexRoute
  '/_auth/_dashboard/workouts/': typeof AuthDashboardWorkoutsIndexRoute
  '/_auth/_dashboard/clients/$clientId': typeof AuthDashboardClientsClientIdRouteWithChildren
  '/_auth/_dashboard/clients/$clientId/_layout': typeof AuthDashboardClientsClientIdLayoutRouteWithChildren
  '/_auth/_dashboard/settings/_layout/organisation': typeof AuthDashboardSettingsLayoutOrganisationRoute
  '/_auth/_dashboard/settings/_layout/security': typeof AuthDashboardSettingsLayoutSecurityRoute
  '/_auth/_dashboard/settings/_layout/subscription': typeof AuthDashboardSettingsLayoutSubscriptionRoute
  '/_auth/_dashboard/settings/_layout/': typeof AuthDashboardSettingsLayoutIndexRoute
  '/_auth/_dashboard/clients/$clientId/_layout/activity': typeof AuthDashboardClientsClientIdLayoutActivityRoute
  '/_auth/_dashboard/clients/$clientId/_layout/gallery': typeof AuthDashboardClientsClientIdLayoutGalleryRoute
  '/_auth/_dashboard/clients/$clientId/_layout/habits': typeof AuthDashboardClientsClientIdLayoutHabitsRoute
  '/_auth/_dashboard/clients/$clientId/_layout/metrics': typeof AuthDashboardClientsClientIdLayoutMetricsRoute
  '/_auth/_dashboard/clients/$clientId/_layout/nutrition': typeof AuthDashboardClientsClientIdLayoutNutritionRoute
  '/_auth/_dashboard/clients/$clientId/_layout/roadmap': typeof AuthDashboardClientsClientIdLayoutRoadmapRoute
  '/_auth/_dashboard/clients/$clientId/_layout/settings': typeof AuthDashboardClientsClientIdLayoutSettingsRoute
  '/_auth/_dashboard/clients/$clientId/_layout/training': typeof AuthDashboardClientsClientIdLayoutTrainingRoute
  '/_auth/_dashboard/clients/$clientId/_layout/vault': typeof AuthDashboardClientsClientIdLayoutVaultRoute
  '/_auth/_dashboard/clients/$clientId/_layout/': typeof AuthDashboardClientsClientIdLayoutIndexRoute
  '/_auth/_dashboard/clients/$clientId/_layout/checkin/compare': typeof AuthDashboardClientsClientIdLayoutCheckinCompareRoute
  '/_auth/_dashboard/clients/$clientId/_layout/checkin/': typeof AuthDashboardClientsClientIdLayoutCheckinIndexRoute
  '/_auth/_dashboard/clients/$clientId/_layout/checkin/$formId/$responseId': typeof AuthDashboardClientsClientIdLayoutCheckinFormIdResponseIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/join'
    | '/reset-password'
    | '/setup'
    | '/forgot'
    | '/login'
    | '/register'
    | '/workout-session'
    | '/auth/callback'
    | '/oauth/consent'
    | '/branding'
    | '/chat'
    | '/checkins'
    | '/dashboard'
    | '/exercises'
    | '/foods'
    | '/getting-started'
    | '/habits'
    | '/meals'
    | '/metrics'
    | '/packages'
    | '/refer'
    | '/supplements'
    | '/team'
    | '/upgrade'
    | '/vault'
    | '/forms/$formId'
    | '/leads/$leadId'
    | '/nutrition/$templateId'
    | '/settings'
    | '/training/$templateId'
    | '/workouts/$workoutId'
    | '/clients'
    | '/forms'
    | '/leads'
    | '/nutrition'
    | '/training'
    | '/workouts'
    | '/clients/$clientId'
    | '/settings/organisation'
    | '/settings/security'
    | '/settings/subscription'
    | '/settings/'
    | '/clients/$clientId/activity'
    | '/clients/$clientId/gallery'
    | '/clients/$clientId/habits'
    | '/clients/$clientId/metrics'
    | '/clients/$clientId/nutrition'
    | '/clients/$clientId/roadmap'
    | '/clients/$clientId/settings'
    | '/clients/$clientId/training'
    | '/clients/$clientId/vault'
    | '/clients/$clientId/'
    | '/clients/$clientId/checkin/compare'
    | '/clients/$clientId/checkin'
    | '/clients/$clientId/checkin/$formId/$responseId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/join'
    | '/reset-password'
    | '/setup'
    | '/forgot'
    | '/login'
    | '/register'
    | '/workout-session'
    | '/auth/callback'
    | '/oauth/consent'
    | '/branding'
    | '/chat'
    | '/checkins'
    | '/dashboard'
    | '/exercises'
    | '/foods'
    | '/getting-started'
    | '/habits'
    | '/meals'
    | '/metrics'
    | '/packages'
    | '/refer'
    | '/supplements'
    | '/team'
    | '/upgrade'
    | '/vault'
    | '/forms/$formId'
    | '/leads/$leadId'
    | '/nutrition/$templateId'
    | '/settings'
    | '/training/$templateId'
    | '/workouts/$workoutId'
    | '/clients'
    | '/forms'
    | '/leads'
    | '/nutrition'
    | '/training'
    | '/workouts'
    | '/clients/$clientId'
    | '/settings/organisation'
    | '/settings/security'
    | '/settings/subscription'
    | '/clients/$clientId/activity'
    | '/clients/$clientId/gallery'
    | '/clients/$clientId/habits'
    | '/clients/$clientId/metrics'
    | '/clients/$clientId/nutrition'
    | '/clients/$clientId/roadmap'
    | '/clients/$clientId/settings'
    | '/clients/$clientId/training'
    | '/clients/$clientId/vault'
    | '/clients/$clientId/checkin/compare'
    | '/clients/$clientId/checkin'
    | '/clients/$clientId/checkin/$formId/$responseId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/join'
    | '/reset-password'
    | '/(setup)/setup'
    | '/(unauth)/forgot'
    | '/(unauth)/login'
    | '/(unauth)/register'
    | '/_auth/_dashboard'
    | '/_auth/workout-session'
    | '/auth/callback'
    | '/oauth/consent'
    | '/_auth/_dashboard/branding'
    | '/_auth/_dashboard/chat'
    | '/_auth/_dashboard/checkins'
    | '/_auth/_dashboard/dashboard'
    | '/_auth/_dashboard/exercises'
    | '/_auth/_dashboard/foods'
    | '/_auth/_dashboard/getting-started'
    | '/_auth/_dashboard/habits'
    | '/_auth/_dashboard/meals'
    | '/_auth/_dashboard/metrics'
    | '/_auth/_dashboard/packages'
    | '/_auth/_dashboard/refer'
    | '/_auth/_dashboard/supplements'
    | '/_auth/_dashboard/team'
    | '/_auth/_dashboard/upgrade'
    | '/_auth/_dashboard/vault'
    | '/_auth/_dashboard/forms/$formId'
    | '/_auth/_dashboard/leads/$leadId'
    | '/_auth/_dashboard/nutrition/$templateId'
    | '/_auth/_dashboard/settings'
    | '/_auth/_dashboard/settings/_layout'
    | '/_auth/_dashboard/training/$templateId'
    | '/_auth/_dashboard/workouts/$workoutId'
    | '/_auth/_dashboard/clients/'
    | '/_auth/_dashboard/forms/'
    | '/_auth/_dashboard/leads/'
    | '/_auth/_dashboard/nutrition/'
    | '/_auth/_dashboard/training/'
    | '/_auth/_dashboard/workouts/'
    | '/_auth/_dashboard/clients/$clientId'
    | '/_auth/_dashboard/clients/$clientId/_layout'
    | '/_auth/_dashboard/settings/_layout/organisation'
    | '/_auth/_dashboard/settings/_layout/security'
    | '/_auth/_dashboard/settings/_layout/subscription'
    | '/_auth/_dashboard/settings/_layout/'
    | '/_auth/_dashboard/clients/$clientId/_layout/activity'
    | '/_auth/_dashboard/clients/$clientId/_layout/gallery'
    | '/_auth/_dashboard/clients/$clientId/_layout/habits'
    | '/_auth/_dashboard/clients/$clientId/_layout/metrics'
    | '/_auth/_dashboard/clients/$clientId/_layout/nutrition'
    | '/_auth/_dashboard/clients/$clientId/_layout/roadmap'
    | '/_auth/_dashboard/clients/$clientId/_layout/settings'
    | '/_auth/_dashboard/clients/$clientId/_layout/training'
    | '/_auth/_dashboard/clients/$clientId/_layout/vault'
    | '/_auth/_dashboard/clients/$clientId/_layout/'
    | '/_auth/_dashboard/clients/$clientId/_layout/checkin/compare'
    | '/_auth/_dashboard/clients/$clientId/_layout/checkin/'
    | '/_auth/_dashboard/clients/$clientId/_layout/checkin/$formId/$responseId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  JoinRoute: typeof JoinRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  setupSetupRoute: typeof setupSetupRoute
  unauthForgotRoute: typeof unauthForgotRoute
  unauthLoginRoute: typeof unauthLoginRoute
  unauthRegisterRoute: typeof unauthRegisterRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  OauthConsentRoute: typeof OauthConsentRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  JoinRoute: JoinRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  setupSetupRoute: setupSetupRoute,
  unauthForgotRoute: unauthForgotRoute,
  unauthLoginRoute: unauthLoginRoute,
  unauthRegisterRoute: unauthRegisterRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  OauthConsentRoute: OauthConsentRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/join",
        "/reset-password",
        "/(setup)/setup",
        "/(unauth)/forgot",
        "/(unauth)/login",
        "/(unauth)/register",
        "/auth/callback",
        "/oauth/consent"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/_dashboard",
        "/_auth/workout-session"
      ]
    },
    "/join": {
      "filePath": "join.tsx"
    },
    "/reset-password": {
      "filePath": "reset-password.tsx"
    },
    "/(setup)/setup": {
      "filePath": "(setup)/setup.tsx"
    },
    "/(unauth)/forgot": {
      "filePath": "(unauth)/forgot.tsx"
    },
    "/(unauth)/login": {
      "filePath": "(unauth)/login.tsx"
    },
    "/(unauth)/register": {
      "filePath": "(unauth)/register.tsx"
    },
    "/_auth/_dashboard": {
      "filePath": "_auth/_dashboard.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/_dashboard/branding",
        "/_auth/_dashboard/chat",
        "/_auth/_dashboard/checkins",
        "/_auth/_dashboard/dashboard",
        "/_auth/_dashboard/exercises",
        "/_auth/_dashboard/foods",
        "/_auth/_dashboard/getting-started",
        "/_auth/_dashboard/habits",
        "/_auth/_dashboard/meals",
        "/_auth/_dashboard/metrics",
        "/_auth/_dashboard/packages",
        "/_auth/_dashboard/refer",
        "/_auth/_dashboard/supplements",
        "/_auth/_dashboard/team",
        "/_auth/_dashboard/upgrade",
        "/_auth/_dashboard/vault",
        "/_auth/_dashboard/forms/$formId",
        "/_auth/_dashboard/leads/$leadId",
        "/_auth/_dashboard/nutrition/$templateId",
        "/_auth/_dashboard/settings",
        "/_auth/_dashboard/training/$templateId",
        "/_auth/_dashboard/workouts/$workoutId",
        "/_auth/_dashboard/clients/",
        "/_auth/_dashboard/forms/",
        "/_auth/_dashboard/leads/",
        "/_auth/_dashboard/nutrition/",
        "/_auth/_dashboard/training/",
        "/_auth/_dashboard/workouts/",
        "/_auth/_dashboard/clients/$clientId"
      ]
    },
    "/_auth/workout-session": {
      "filePath": "_auth/workout-session.tsx",
      "parent": "/_auth"
    },
    "/auth/callback": {
      "filePath": "auth/callback.tsx"
    },
    "/oauth/consent": {
      "filePath": "oauth/consent.tsx"
    },
    "/_auth/_dashboard/branding": {
      "filePath": "_auth/_dashboard/branding.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/chat": {
      "filePath": "_auth/_dashboard/chat.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/checkins": {
      "filePath": "_auth/_dashboard/checkins.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/dashboard": {
      "filePath": "_auth/_dashboard/dashboard.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/exercises": {
      "filePath": "_auth/_dashboard/exercises.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/foods": {
      "filePath": "_auth/_dashboard/foods.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/getting-started": {
      "filePath": "_auth/_dashboard/getting-started.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/habits": {
      "filePath": "_auth/_dashboard/habits.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/meals": {
      "filePath": "_auth/_dashboard/meals.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/metrics": {
      "filePath": "_auth/_dashboard/metrics.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/packages": {
      "filePath": "_auth/_dashboard/packages.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/refer": {
      "filePath": "_auth/_dashboard/refer.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/supplements": {
      "filePath": "_auth/_dashboard/supplements.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/team": {
      "filePath": "_auth/_dashboard/team.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/upgrade": {
      "filePath": "_auth/_dashboard/upgrade.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/vault": {
      "filePath": "_auth/_dashboard/vault.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/forms/$formId": {
      "filePath": "_auth/_dashboard/forms/$formId.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/leads/$leadId": {
      "filePath": "_auth/_dashboard/leads/$leadId.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/nutrition/$templateId": {
      "filePath": "_auth/_dashboard/nutrition/$templateId.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/settings": {
      "filePath": "_auth/_dashboard/settings",
      "parent": "/_auth/_dashboard",
      "children": [
        "/_auth/_dashboard/settings/_layout"
      ]
    },
    "/_auth/_dashboard/settings/_layout": {
      "filePath": "_auth/_dashboard/settings/_layout.tsx",
      "parent": "/_auth/_dashboard/settings",
      "children": [
        "/_auth/_dashboard/settings/_layout/organisation",
        "/_auth/_dashboard/settings/_layout/security",
        "/_auth/_dashboard/settings/_layout/subscription",
        "/_auth/_dashboard/settings/_layout/"
      ]
    },
    "/_auth/_dashboard/training/$templateId": {
      "filePath": "_auth/_dashboard/training/$templateId.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/workouts/$workoutId": {
      "filePath": "_auth/_dashboard/workouts/$workoutId.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/clients/": {
      "filePath": "_auth/_dashboard/clients/index.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/forms/": {
      "filePath": "_auth/_dashboard/forms/index.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/leads/": {
      "filePath": "_auth/_dashboard/leads/index.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/nutrition/": {
      "filePath": "_auth/_dashboard/nutrition/index.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/training/": {
      "filePath": "_auth/_dashboard/training/index.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/workouts/": {
      "filePath": "_auth/_dashboard/workouts/index.tsx",
      "parent": "/_auth/_dashboard"
    },
    "/_auth/_dashboard/clients/$clientId": {
      "filePath": "_auth/_dashboard/clients/$clientId",
      "parent": "/_auth/_dashboard",
      "children": [
        "/_auth/_dashboard/clients/$clientId/_layout"
      ]
    },
    "/_auth/_dashboard/clients/$clientId/_layout": {
      "filePath": "_auth/_dashboard/clients/$clientId/_layout.tsx",
      "parent": "/_auth/_dashboard/clients/$clientId",
      "children": [
        "/_auth/_dashboard/clients/$clientId/_layout/activity",
        "/_auth/_dashboard/clients/$clientId/_layout/gallery",
        "/_auth/_dashboard/clients/$clientId/_layout/habits",
        "/_auth/_dashboard/clients/$clientId/_layout/metrics",
        "/_auth/_dashboard/clients/$clientId/_layout/nutrition",
        "/_auth/_dashboard/clients/$clientId/_layout/roadmap",
        "/_auth/_dashboard/clients/$clientId/_layout/settings",
        "/_auth/_dashboard/clients/$clientId/_layout/training",
        "/_auth/_dashboard/clients/$clientId/_layout/vault",
        "/_auth/_dashboard/clients/$clientId/_layout/",
        "/_auth/_dashboard/clients/$clientId/_layout/checkin/compare",
        "/_auth/_dashboard/clients/$clientId/_layout/checkin/",
        "/_auth/_dashboard/clients/$clientId/_layout/checkin/$formId/$responseId"
      ]
    },
    "/_auth/_dashboard/settings/_layout/organisation": {
      "filePath": "_auth/_dashboard/settings/_layout/organisation.tsx",
      "parent": "/_auth/_dashboard/settings/_layout"
    },
    "/_auth/_dashboard/settings/_layout/security": {
      "filePath": "_auth/_dashboard/settings/_layout/security.tsx",
      "parent": "/_auth/_dashboard/settings/_layout"
    },
    "/_auth/_dashboard/settings/_layout/subscription": {
      "filePath": "_auth/_dashboard/settings/_layout/subscription.tsx",
      "parent": "/_auth/_dashboard/settings/_layout"
    },
    "/_auth/_dashboard/settings/_layout/": {
      "filePath": "_auth/_dashboard/settings/_layout/index.tsx",
      "parent": "/_auth/_dashboard/settings/_layout"
    },
    "/_auth/_dashboard/clients/$clientId/_layout/activity": {
      "filePath": "_auth/_dashboard/clients/$clientId/_layout/activity.tsx",
      "parent": "/_auth/_dashboard/clients/$clientId/_layout"
    },
    "/_auth/_dashboard/clients/$clientId/_layout/gallery": {
      "filePath": "_auth/_dashboard/clients/$clientId/_layout/gallery.tsx",
      "parent": "/_auth/_dashboard/clients/$clientId/_layout"
    },
    "/_auth/_dashboard/clients/$clientId/_layout/habits": {
      "filePath": "_auth/_dashboard/clients/$clientId/_layout/habits.tsx",
      "parent": "/_auth/_dashboard/clients/$clientId/_layout"
    },
    "/_auth/_dashboard/clients/$clientId/_layout/metrics": {
      "filePath": "_auth/_dashboard/clients/$clientId/_layout/metrics.tsx",
      "parent": "/_auth/_dashboard/clients/$clientId/_layout"
    },
    "/_auth/_dashboard/clients/$clientId/_layout/nutrition": {
      "filePath": "_auth/_dashboard/clients/$clientId/_layout/nutrition.tsx",
      "parent": "/_auth/_dashboard/clients/$clientId/_layout"
    },
    "/_auth/_dashboard/clients/$clientId/_layout/roadmap": {
      "filePath": "_auth/_dashboard/clients/$clientId/_layout/roadmap.tsx",
      "parent": "/_auth/_dashboard/clients/$clientId/_layout"
    },
    "/_auth/_dashboard/clients/$clientId/_layout/settings": {
      "filePath": "_auth/_dashboard/clients/$clientId/_layout/settings.tsx",
      "parent": "/_auth/_dashboard/clients/$clientId/_layout"
    },
    "/_auth/_dashboard/clients/$clientId/_layout/training": {
      "filePath": "_auth/_dashboard/clients/$clientId/_layout/training.tsx",
      "parent": "/_auth/_dashboard/clients/$clientId/_layout"
    },
    "/_auth/_dashboard/clients/$clientId/_layout/vault": {
      "filePath": "_auth/_dashboard/clients/$clientId/_layout/vault.tsx",
      "parent": "/_auth/_dashboard/clients/$clientId/_layout"
    },
    "/_auth/_dashboard/clients/$clientId/_layout/": {
      "filePath": "_auth/_dashboard/clients/$clientId/_layout/index.tsx",
      "parent": "/_auth/_dashboard/clients/$clientId/_layout"
    },
    "/_auth/_dashboard/clients/$clientId/_layout/checkin/compare": {
      "filePath": "_auth/_dashboard/clients/$clientId/_layout/checkin/compare.tsx",
      "parent": "/_auth/_dashboard/clients/$clientId/_layout"
    },
    "/_auth/_dashboard/clients/$clientId/_layout/checkin/": {
      "filePath": "_auth/_dashboard/clients/$clientId/_layout/checkin/index.tsx",
      "parent": "/_auth/_dashboard/clients/$clientId/_layout"
    },
    "/_auth/_dashboard/clients/$clientId/_layout/checkin/$formId/$responseId": {
      "filePath": "_auth/_dashboard/clients/$clientId/_layout/checkin/$formId.$responseId.tsx",
      "parent": "/_auth/_dashboard/clients/$clientId/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
